<div class="info-modal" *ngIf="open" (click)="close()">
  <div
    class="info-modal__dialog"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >
    <header class="info-modal__header">
      <h3 class="info-modal__title" [innerHTML]="title | safeHtml"></h3>
      <button
        type="button"
        class="info-modal__close"
        aria-label="Cerrar"
        (click)="close()"
      >
        <i class="fas fa-times"></i>
      </button>
    </header>

    <div class="info-modal__body rich-text" [innerHTML]="content | safeHtml"></div>
  </div>
</div>
